import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RoleService } from '__services';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit {
  menu: any[];

  constructor(
    private roleService: RoleService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.roleService.getMenus();
    this.menu = this.roleService.module;
  }

  ngAfterViewInit() {
    this.activatedRoute.url.subscribe((observer) => {
      if(this.menu) {
        const currentSubmenu = this.menu.find((submenu) =>
        submenu.link.includes(observer[0]?.path)
        );
        if (currentSubmenu) {
          currentSubmenu.isActive = true;
        }
      }
    });
  }

  onNavToDashBoard() {
    //Set inactive for before selected module
    const module = this.menu.find((item) => item?.isActive);
    if (module) {
      module.isActive = false;
    }
  }
}
